/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Doc recognition error: unknown error
 * @export
 * @interface PaxCheckUnknownRecognitionError
 */
export interface PaxCheckUnknownRecognitionError {
    /**
     * Error message
     * @type {string}
     * @memberof PaxCheckUnknownRecognitionError
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof PaxCheckUnknownRecognitionError
     */
    type: string;
}

/**
 * Check if a given object implements the PaxCheckUnknownRecognitionError interface.
 */
export function instanceOfPaxCheckUnknownRecognitionError(value: object): value is PaxCheckUnknownRecognitionError {
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function PaxCheckUnknownRecognitionErrorFromJSON(json: any): PaxCheckUnknownRecognitionError {
    return PaxCheckUnknownRecognitionErrorFromJSONTyped(json, false);
}

export function PaxCheckUnknownRecognitionErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckUnknownRecognitionError {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'],
        'type': json['type'],
    };
}

export function PaxCheckUnknownRecognitionErrorToJSON(json: any): PaxCheckUnknownRecognitionError {
    return PaxCheckUnknownRecognitionErrorToJSONTyped(json, false);
}

export function PaxCheckUnknownRecognitionErrorToJSONTyped(value?: PaxCheckUnknownRecognitionError | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': value['message'],
        'type': value['type'],
    };
}

